<!-- 觉醒  基本信息 -->
<template>
  <div class="TableContent TableContents_2">
    <p class="setctionTitle">基本信息</p>
    <div class="dInfo_1">
      <span class="sImg">
        <img
          v-if="finalSkill.name"
          :src="
            jx_lv_img(finalSkill.lv, finalSkill.minglian_value, finalSkill.name)
          "
        />
      </span>
      <span class="sTitle">{{ finalSkill.name }}</span>
      <span class="sExp">等级:{{ finalSkill.lv }}</span>
      <span class="sExp">封禁之力:{{ finalSkill.releaseScale }}</span>
      <span class="sExp">护禁之力:{{ finalSkill.protectScale }}</span>
    </div>
    <ul class="DataListStyle">
      <li class="li_k1">溟禅炼道：</li>
      <li class="li1">{{ finalSkill.minglian_value }}</li>
      <li class="li_k1">当前炼护总数：</li>
      <li class="li1">{{ finalSkill.enh2Num }}</li>
      <li class="li_k1">炼护转化溟炼值：</li>
      <li class="li1">{{ finalSkill.minglian_changeValue }}</li>
      <li class="li_k1">觉醒度：</li>
      <li class="li1" style="margin-bottom: 18px">{{ finalSkill.awake }}</li>

      <template v-for="(a, a_index) in attr" :key="a_index">
        <!-- 力、体、敏、疾、魂、念 -->
        <li class="li_k2">{{ a.text }}：</li>
        <li class="li2">{{ baseCache[a.key] || 0 }}</li>
        <li class="li_k3">{{ a.text }}资质：</li>
        <li class="li3">{{ apt[`${a.key}Apt`] || 0 }}</li>
      </template>
    </ul>
  </div>
</template>

<script setup>
const { attr } = inject('Game');

const { jx_lv_img } = inject('filters');

const props = defineProps({
  finalSkill: {
    type: Object,
    default: () => ({}),
  },
});

const baseCache = computed(() => {
  return props.baseCache || {};
});

const apt = computed(() => {
  return props.finalSkill.apt || {};
});
</script>
